import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import {
  baseUrl,
  customHeaders,
  thriweMarketPlacePhillipinesUrl,
  thriweMarketPlaceUaeUrl,
  thriweMarketPlaceUrl,
} from '../../../../Containers/Config/index.js';
import { CANCEL_BOOKING_V2, CANCEL_BOOKING_V2_SUCCESS, CANCEL_BOOKING_V2_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* cancelBookingV2({ payload }) {
  try {
    let url = ['HSBC_BEACH_CLUB', 'ENBD_NATIONAL_DAY', 'MASTERCARD_FAB', 'CBD_GOLF_V2', 'VISA_PVT', 'MASTERCARD_UAE', 'MASHREQ', 'EIB_V2'].includes(
      Constant.PROJECT_CODE,
    )
      ? thriweMarketPlaceUaeUrl
      : ['HSBC_BENEFITS'].includes(Constant.PROJECT_CODE)
        ? thriweMarketPlacePhillipinesUrl
        : thriweMarketPlaceUrl;

    const response = yield call(apiCall, {
      url: `${url}/v2/admin/cancel-booking/${payload?.urlParams?.booking_id}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CANCEL_BOOKING_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CANCEL_BOOKING_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CANCEL_BOOKING_V2_ERROR, payload: error });
  }
}

export function* watchCancelBookingV2() {
  yield takeEvery(CANCEL_BOOKING_V2, cancelBookingV2);
}

function* cancelBookingV2Saga() {
  yield all([fork(watchCancelBookingV2)]);
}

export default cancelBookingV2Saga;
